import { apiService } from "@/services/apiService";
import { endpoints } from "@/config/endpoints";
import { pickBy } from "lodash";

export default {
  fetchAvailableGmbAttributes({
    facilitiesIds = [],
    onlySet = false,
    valueTypes = []
  }) {
    const params = {
      facilities_ids: facilitiesIds.join(","),
      only_set: onlySet,
      value_type: valueTypes.join(",")
    };
    return apiService.post(endpoints.gmbAttributes, pickBy(params));
  }
};
